/**
 * 颜色枚举常量
 * 从XML资源文件转换而来
 */
export enum Colors {
  // 基础颜色
  PURPLE_200 = '#FFBB86FC',
  PURPLE_500 = '#FF6200EE',
  PURPLE_700 = '#FF3700B3',
  TEAL_200 = '#FF03DAC5',
  TEAL_500 = '#009688',
  TEAL_700 = '#FF018786',
  BLACK = '#FF000000',
  WHITE = '#FFFFFFFF',
  WHITE_GRAY = '#e2e8f0',
  GREEN = '#00ff00',
  ORANGE = '#ff8000',
  RED = '#ff0000',
  
  // 灰色系列
  BALTIC_SEA = '#2C2C30',
  PLATINUM = '#E4E4E4',
  SMOKEY_GREY = '#707070',
  DAVY_GREY = '#58585B',
  OSLO_GREY = '#898A8D',
  NIGHT_GREY = '#353535',
  DIALOG_PRESSED = '#31383E',
  DIALOG_BG = '#3B444B',
  RANGOON_GREEN = '#181818',
  GREY = '#808080',
  GREY_30 = '#30808080',
  LIGHT_GRAY = '#CCCCCC',
  
  // 蓝色系列
  MARINE = '#002b66',
  COOL_BLUE = '#498ab4',
  
  // 绿色系列
  ALGAE_GREEN = '#5de878',
  AQUA_MARINE = '#25d9cc',
  MEDIUM_TURQUOISE = '#57c5d6',
  SPA_TEMP = '#5DE878',
  
  // 黄色系列
  BUS_YELLOW = '#ed9c19',
  BRIGHT_SUN = '#fed742',
  
  // 粉色系列
  PINK_PEARL = '#eeadcb',
  MEDIUM_PINK = '#f95f8f',
  
  // 红色系列
  RUBY_RED = '#FE1B1B',
  
  // pH值颜色
  PH_0_PERCENT = '#800000',
  PH_15_PERCENT = '#990000',
  PH_30_PERCENT = '#b30000',
  PH_45_PERCENT = '#cc0000',
  PH_60_PERCENT = '#cc3300',
  PH_75_PERCENT = '#cc6600',
  PH_90_PERCENT = '#cccc00',
  PH_95_PERCENT = '#99cc00',
  PH_NORMAL = '#2eb82e',
  
  // 信号强度颜色
  STRONG_SIGNAL = '#00ff00',
  GOOD_SIGNAL = '#e6e00b',
  AVERAGE_SIGNAL = '#f7931e',
  BAD_SIGNAL = '#FE1B1B',
  WEAK_SIGNAL = '#e6e6e6',
  
  // 主题颜色
  PRIMARY_COLOR = '#6200EE',
  PRIMARY_TEXT_COLOR = '#000000',
  SECONDARY_TEXT_COLOR = '#757575',
  DIALOG_BACKGROUND_COLOR = '#222222'
}

/**
 * 获取pH值对应的颜色
 * @param phValue pH值
 * @returns 对应的颜色代码
 */
export const getPhColor = (phValue: number): string => {
  if (phValue < 6.8) {
    if (phValue < 6.2) return Colors.PH_0_PERCENT;
    if (phValue < 6.4) return Colors.PH_15_PERCENT;
    if (phValue < 6.6) return Colors.PH_30_PERCENT;
    return Colors.PH_45_PERCENT;
  } else if (phValue > 7.8) {
    if (phValue > 8.4) return Colors.PH_0_PERCENT;
    if (phValue > 8.2) return Colors.PH_15_PERCENT;
    if (phValue > 8.0) return Colors.PH_30_PERCENT;
    return Colors.PH_45_PERCENT;
  } else {
    if (phValue >= 7.2 && phValue <= 7.6) return Colors.PH_NORMAL;
    if (phValue > 7.6 && phValue <= 7.8) return Colors.PH_95_PERCENT;
    if (phValue >= 6.8 && phValue < 7.2) return Colors.PH_95_PERCENT;
    return Colors.PH_90_PERCENT;
  }
};

/**
 * 获取信号强度对应的颜色
 * @param signalStrength 信号强度百分比 (0-100)
 * @returns 对应的颜色代码
 */
export const getSignalColor = (signalStrength: number): string => {
  if (signalStrength >= 80) return Colors.STRONG_SIGNAL;
  if (signalStrength >= 60) return Colors.GOOD_SIGNAL;
  if (signalStrength >= 40) return Colors.AVERAGE_SIGNAL;
  if (signalStrength >= 20) return Colors.BAD_SIGNAL;
  return Colors.WEAK_SIGNAL;
};

/**
 * 获取过滤器健康状态对应的颜色
 * @param healthPercentage 健康百分比 (0-100)
 * @returns 对应的颜色代码
 */
export const getFilterHealthColor = (healthPercentage: number): string => {
  if (healthPercentage < 10) return Colors.RED;
  if (healthPercentage <= 40) return Colors.ORANGE;
  return Colors.GREEN;
};